import { render, staticRenderFns } from "./ResMng.vue?vue&type=template&id=6dd22c76&"
import script from "./ResMng.vue?vue&type=script&lang=js&"
export * from "./ResMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports